import { createAsyncThunk } from '@reduxjs/toolkit';
import { login ,forgotPassword} from '../../services/authServices';
import { getDefaultRouteByAccess } from '../../utils/navigationHelper';

export const loginUser = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const res = await login(credentials);

    if (res.error) {
      return rejectWithValue(res.message);
    }

    const accessList = res.tab || [];
   
    const defaultRoute = getDefaultRouteByAccess(accessList);
  
    const updatedData = {
      ...res,
      route_path: defaultRoute,
    };
    return updatedData;
  } catch (error) {
    console.error("❌ Login error:", error);
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const logoutUser = createAsyncThunk('auth/logout', async (_, { rejectWithValue }) => {
  try {
    //await logout();
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const forgotPasswordUser = createAsyncThunk(
  "auth/forgotPassword",
  async (email, { rejectWithValue }) => {
    try {
      const res = await forgotPassword(email);

      if (res.error === false) {
        return res.message;
      } else {
        return rejectWithValue(res.message);
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

